const FORMAT = /^\d{2}[a-z]{2}\d{3}$/i

module.exports = function() {
  // Return true if string has 2 numeric chars followed by 2 alphabetic chars then 3 numeric chars. Used by skatteverket for tjänstebilar
  return value => {
    return value && FORMAT.test(value)
  }
}
